import { IS_DEV, IS_TESTING } from "@/__main__/constants.mjs";
import { appURLs } from "@/app/constants.mjs";
import { unknownIcon } from "@/app/constants-misc.mjs";
import type { GameDefinition } from "@/app/game-definition.mjs";
import { GAME_SYMBOL_UNKNOWN } from "@/game-unknown/definition-symbol.mjs";
import routes from "@/game-unknown/routes.mjs";
import GameIconBoxUnknown from "@/inline-assets/game-icon-box-unknown.svg";
import FriendGameIconBoxUnknown from "@/inline-assets/game-icon-friend-box-unknown.svg";
import GameShapeUnknown from "@/inline-assets/game-unknown-icon.svg";
import nameImg from "@/inline-assets/game-unknown-name.webp";

export { GAME_SYMBOL_UNKNOWN };

const definition = {
  gameSymbol: GAME_SYMBOL_UNKNOWN,
  icon: unknownIcon,
  iconShape: GameShapeUnknown,
  iconBox: GameIconBoxUnknown,
  iconBadge: FriendGameIconBoxUnknown,
  imageHero: `${appURLs.CDN_PLAIN}/blitz/games/assest/hero-logo/hero-logo-unknown.png`,
  imageBanner: null, // this one is optional
  imageKeyart: `${appURLs.CDN}/blitz/ui/img/game-cover/unknown.webp`,
  imageWordmark: nameImg,
  isActive: IS_DEV && !IS_TESTING,
  fullName: [
    "common:games.unknown.long",
    `PlayerDeli's Super Meat Slicer (literally "Blitz Lite")`,
  ],
  friendlyName: ["common:games.unknown.short", "Super Meat Slicer"],
  preferFriendlyName: true as const,
  shortName: "unknown" as const,
  backendName: "UNKNOWN" as const,
  gameColor: "var(--lime)",

  navLinks: [],
  settings: () => import("@/game-unknown/Settings.jsx"),
  routes,
  meta: {
    pros: [
      {
        name: "delimeats",
        src: () =>
          Promise.resolve({
            default: `${appURLs.CDN_PLAIN}/blitz/ui/img/game-unknown-pro-delimeats.webp`,
          } as const),
      },
      {
        name: "Manny the Cat",
        src: () =>
          Promise.resolve({
            default: `${appURLs.CDN_PLAIN}/blitz/ui/img/game-unknown-pro-mannythecat.webp`,
          } as const),
      },
      {
        name: "Dillo",
        src: () =>
          Promise.resolve({
            default: `${appURLs.CDN_PLAIN}/blitz/ui/img/game-unknown-pro-dillo.webp`,
          } as const),
      },
      {
        name: "EliteTed",
        src: () =>
          Promise.resolve({
            default: "//media.tenor.com/kGkxq5zORIsAAAAd/cute-toad-smile.gif",
          } as const),
      },
    ],
  },
} satisfies GameDefinition<typeof GAME_SYMBOL_UNKNOWN>;

export default definition;
